import { createSlice } from '@reduxjs/toolkit';
import { mergeContainer } from 'ducks/container/operators';
import { Slices } from 'ducks/slices';
import { ContainersAPI } from 'ducks/types/api-types';
import { NullableNumberInterface } from 'ducks/types/type-helpers';

export type ContainerState = NullableNumberInterface<ContainersAPI>;

const initialState: ContainerState = {
  container_id: null,
  job_id: null,
  server_id: null,
  container_identifier: '',
  delete_on_exit: false,
  container_state_id: null,
  container_state_name: '',
  attempt: null,
  is_current: false,
  startup_command: '',
  max_memory_mb: null,
  project_id: null,
  project_name: '',
  organization_id: null,
  organization_name: '',
  running_datetime_utc: '',
  finish_datetime_utc: '',
  running_duration_seconds: null,
};

const containerSlice = createSlice({
  name: Slices.CONTAINER,
  initialState,
  reducers: {
    setContainer: (_, action) => {
      return action.payload;
    },
    clearContainer: () => {
      return initialState;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(mergeContainer.pending, () => {
        return initialState;
      })
      .addCase(mergeContainer.fulfilled, (state, { payload }) => {
        return { ...state, ...payload };
      })
      .addCase(mergeContainer.rejected, () => {
        return initialState;
      });
  },
});

export const { setContainer, clearContainer } = containerSlice.actions;

export default containerSlice.reducer;
